import * as THREE from 'three'
import Experience from './Experience.js'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { Float32Attribute, MathUtils } from 'three'
import gsap from 'gsap'
import EventEmitter from './Utils/EventEmitter.js'

export default class Camera extends EventEmitter
{
    constructor()
    {
        super()
        this.experience = new Experience()
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.canvas = this.experience.canvas
        this.selector = this.experience.selector
        this.time = this.experience.time;
        this.input = this.experience.input;
        this.world = this.experience.world;
        this.ui = this.experience.ui;
        this.islandCount = 6;
        
        

        this.maxAzimuth = 20
        this.minAzimuth = -20
        this.maxPolar = 85
        this.minPolar = 40
        
        this.cameraTargetPos= new THREE.Vector3();
        this.controlTargetPos= new THREE.Vector3();
        this.controlPos = new THREE.Vector3();
        //Camera Lerp
        this.targetCamPos = new THREE.Vector3();
        this.targetControlPos = new THREE.Vector3();
        this.initialControlPos = new THREE.Vector3();
        this.increment = 20;
        this.cameraYOffset = 8;
        this.cameraInitialOffset = 60;
        this.cameraLinearOffset = new THREE.Vector3(0,-4,22);
        
        this.cameraOffset = 30;
                
        this.cameraStartPos = new THREE.Vector3(0,5,50);
        this.controlStartPos = new THREE.Vector3(0,0,0);
        this.cameraStartPosMobile = new THREE.Vector3(0,5,20);
        //Control settings
        this.localPanLimit = 3;
        this.minGlobalPan = new THREE.Vector3( -50, -15, -30);
        this.maxGlobalPan = new THREE.Vector3( 50,400 , 30);
        this.minInfGlobalPan = new THREE.Vector3( -1000, -1000, -1000 );
        this.maxInfGlobalPan = new THREE.Vector3( 1000, 1000, 1000 );
        this.localPanOffset = new THREE.Vector3( 100,20, 100 );
        this.minGlobalPanMobile = new THREE.Vector3( -80, 10, 10 );
        this.maxGlobalPanMobile = new THREE.Vector3( 80, 460, 520 );
        this.maxGlobalZoom = 110;
        this.minGlobalZoom = 8;
        this.mode = 0;
        this.introEnded = false;
        this.v = new THREE.Vector3();
        this.minPan = this.minGlobalPan;
        this.maxPan = this.maxGlobalPan;

        this.dollyStartCam = new THREE.Vector3(2,-2,14);        
        this.dollyStartPos = new THREE.Vector3(2,4,0);
        this.dollyStartCamM = new THREE.Vector3(-8,-2,14);
        this.dollyStartPosM = new THREE.Vector3(-8,4,0);

        this.dollyStartCam2 = new THREE.Vector3(2,-2,19);        
        this.dollyStartCamM2 = new THREE.Vector3(-8,-2,21);        

        this.minDollyPan = new THREE.Vector3( 2,  4, 0);
        this.maxDollyPan = new THREE.Vector3( 30, 4,0);
        this.minDollyPanM = new THREE.Vector3( -8,  4, 0);
        this.maxDollyPanM = new THREE.Vector3( 40, 4,0);

        this.minDollyPan2 = new THREE.Vector3( 0,  4, 0);
        this.maxDollyPan2 = new THREE.Vector3( 35, 4,0);
        this.minDollyPanM2 = new THREE.Vector3( -8,  4, 0);
        this.maxDollyPanM2 = new THREE.Vector3( 45, 4,0);

        this.dollyStartCam3 = new THREE.Vector3(-2,-6,10);
        this.dollyStartPos3 = new THREE.Vector3(0,2,0);    
        this.dollyStartCamM3 = new THREE.Vector3(-3,-6,12);            
        this.dollyStartPosM3 = new THREE.Vector3(3,2,0);
        this.minDollyPan3 = new THREE.Vector3( 0,  2, 0);
        this.maxDollyPan3 = new THREE.Vector3( 27, 2,0);
        this.minDollyPanM3 = new THREE.Vector3( 3,  2, 0);
        this.maxDollyPanM3 = new THREE.Vector3( 31, 2,0);

        this.dollyStartCam4 = new THREE.Vector3(-10,-2,18);        
        this.dollyStartPos4 = new THREE.Vector3(-5,3,0);  
        this.minDollyPan4 = new THREE.Vector3( -5,  3, 0);
        this.maxDollyPan4 = new THREE.Vector3( 35, 3,0);        
        this.dollyStartCamM4 = new THREE.Vector3(-12,-2,18);      
        this.dollyStartPosM4 = new THREE.Vector3(-7,3,0);        
        this.minDollyPanM4 = new THREE.Vector3( -7,  3, 0);
        this.maxDollyPanM4 = new THREE.Vector3( 46, 3,0);

        this.dollyStartCam5 = new THREE.Vector3(5,20,25);        
        this.dollyStartPos5 = new THREE.Vector3(25,28,0);  
        this.minDollyPan5 = new THREE.Vector3( 25,  3, 0);
        this.maxDollyPan5 = new THREE.Vector3( 25, 28,0);        
        this.dollyStartCamM5 = new THREE.Vector3(-10,20,30);      
        this.dollyStartPosM5 = new THREE.Vector3(25,28,0);        
        this.minDollyPanM5 = new THREE.Vector3(25, 5, 0);
        this.maxDollyPanM5 = new THREE.Vector3(25, 28,0);

        this.dollyStartCam6 = new THREE.Vector3(0,12,28);        
        this.dollyStartPos6 = new THREE.Vector3(-15,17,0);  
        this.minDollyPan6 = new THREE.Vector3( -15,  17, 0);
        this.maxDollyPan6 = new THREE.Vector3( 40, 17,0);        
        this.dollyStartCamM6 = new THREE.Vector3(0,12,28);      
        this.dollyStartPosM6 = new THREE.Vector3(-15,17,0);        
        this.minDollyPanM6 = new THREE.Vector3(-15,17, 0);
        this.maxDollyPanM6 = new THREE.Vector3(40, 17,0);



        this.startCamIntro = new THREE.Vector3(this.increment*2.5,70,60)        
        this.startCamIntroM = new THREE.Vector3(0,70,22)
        this.starControlIntro = new THREE.Vector3(this.increment*2.5,70,0)
        this.starControlIntroM = new THREE.Vector3(0,70,0)
        this.screenType;
        this.onAnimation = false;
        if((window.innerWidth / window.innerHeight) < 1.3)
        this.screenType =  2;
        else if((window.innerWidth / window.innerHeight) < 1.45)
        this.screenType =  1;
        else
        this.screenType =  0;        

        this.setInstance()
        this.setControls()
        
    }

    setInstance()
    {
        this.mode = 0;
        this.instance = new THREE.PerspectiveCamera(60, this.sizes.width / this.sizes.height, 0.1, 1000)
        if(this.screenType == 0)
            this.instance.position.set(this.startCamIntro.x,this.startCamIntro.y, this.startCamIntro.z)
        else if(this.screenType == 1)
            this.instance.position.set(this.startCamIntro.x,this.startCamIntro.y, this.startCamIntro.z)
        else
            this.instance.position.set(this.startCamIntroM.x, this.startCamIntroM.y, this.startCamIntroM.z)
        //this.instance.lookAt( this.starControlIntro )
        this.scene.add(this.instance)
    }

    setControls()
    {
        this.controls = new OrbitControls(this.instance, this.canvas)        
            if(this.screenType == 2)
                this.controls.target.set(this.starControlIntroM.x, this.starControlIntroM.y, this.starControlIntroM.z);
            else
                this.controls.target.set(this.starControlIntro.x, this.starControlIntro.y, this.starControlIntro.z);
        
        this.controls.enableDamping = true;    
        this.controls.enablePan = true;
        this.controls.panSpeed = 1;
        this.controls.update();
        /*this.controls.maxZoom = this.maxGlobalZoom
        this.controls.minZoom = this.minGlobalZoom
        this.controls.maxDistance = this.maxGlobalZoom
        this.controls.minDistance = this.minGlobalZoom    */    

        this.controls.addEventListener("change",()=>
        {
            if(this.introEnded && !this.onAnimation)
            {
                this.v.copy(this.controls.target);
            
                this.controls.target.clamp(this.minPan, this.maxPan);
                this.v.sub(this.controls.target);
                this.instance.position.sub(this.v);      
                if(this.experience.loaded && this.input.firstInteraction && this.introEnded)      
                { 
                    this.onFirstInteraction();                
                }
            }
        })  
    }
    progressorEnded()
    {        
        if(this.experience.state==null)
        {
            this.animateStart();
        }
        else
        {
            this.onAnimation = true;
            this.experience.tapType = parseInt(this.experience.state);
            this.experience.curIndex = parseInt(this.experience.state);
            this.targetCamPos = this.CalcCamLinearPos(this.experience.curIndex);
            this.targetControlPos = this.CalcLinearPos(this.experience.curIndex); 
            
            this.instance.position.set(this.targetCamPos.x, this.targetCamPos.y+ this.cameraYOffset, this.targetCamPos.z);
            this.controls.target.set(this.targetControlPos.x, this.targetControlPos.y, this.targetControlPos.z);
            this.controls.update();
            this.minPan = this.targetControlPos.clone().sub( new THREE.Vector3(this.localPanLimit,this.localPanLimit,this.localPanLimit));
            this.maxPan = this.targetControlPos.clone().add( new THREE.Vector3(this.localPanLimit,this.localPanLimit,this.localPanLimit));
            this.controls.maxZoom = 25
            this.controls.maxDistance = 25
            this.controls.enabled = true;
            this.onAnimation = false;
            this.trigger('quickEntry'); 
            this.introEnded = true;
        }
    }

    onFirstInteraction()
    {
        this.input.firstInteraction = false;
        this.trigger('onFirstInteraction')
    }

    resize()
    {
        this.instance.aspect = this.sizes.width / this.sizes.height
        this.instance.updateProjectionMatrix()
    }

    update()
    {
        if(this.introEnded && !this.onAnimation)
        this.controls.update()
    }

    poISelected()
    {
        switch(this.experience.tapType)
        {
            case 2:
                    if(this.experience.curIndex == 7)
                this.currentCameraOffset = this.cameraOffsetMobileSpecial;
            else
                this.currentCameraOffset = this.cameraOffsetMobile;
                    break;
                default:
            if(this.experience == 7)
                this.currentCameraOffset = this.cameraOffsetSpecial;
            else
                this.currentCameraOffset = this.cameraOffset;
                break;
        }
        this.LerpCamera();        
    }

    LerpCamera()
    {
        this.controlPos = this.instance.position

        this.targetCamPos = this.CalcCamLinearPos(this.experience.curIndex)
        this.targetControlPos = this.CalcLinearPos(this.experience.curIndex)                          
    
        this.initialControlPos = this.controls.target
        this.minPan = new THREE.Vector3( -10, - 15, - 30 );
        this.maxPan = new THREE.Vector3( 110, 15, 30 );
        gsap.to(this.controlPos, {                        
            duration: 0.5,
            x: this.targetCamPos.x, y: this.targetCamPos.y + this.cameraYOffset, z: this.targetCamPos.z,
            onStart: ()=>{
                this.controls.enabled = false;
                this.onAnimation = true;
                },
            onUpdate: ()=>{
                this.instance.position.set(this.controlPos.x, this.controlPos.y, this.controlPos.z);
                },
            onComplete: ()=>{
                this.controls.enabled = true;
                this.onAnimation = false;
                }
    }).play();
        
    gsap.to(this.initialControlPos, {                        
        duration: 0.5,
        x: this.targetControlPos.x, y: this.targetControlPos.y, z: this.targetControlPos.z,
        onStart:  ()=> {
            this.controls.enabled = false;
            },
        onUpdate:  ()=> {                    
            this.instance.lookAt(this.initialControlPos)
            this.controls.update();
            },
        onComplete:  ()=> {
            this.minPan = this.targetControlPos.clone().sub( new THREE.Vector3(this.localPanLimit,this.localPanLimit,this.localPanLimit));
            this.maxPan = this.targetControlPos.clone().add( new THREE.Vector3(this.localPanLimit,this.localPanLimit,this.localPanLimit));
            this.controls.maxZoom = 25
            this.controls.maxDistance = 25
            this.controls.enabled = true;
            this.trigger('onEndCameraMovement');
            }       
    }).play();
    }

    leftCamera()
    {
        if(this.experience.curIndex >0)    
            this.experience.curIndex--;
        else
            this.experience.curIndex = this.islandCount-1            
        this.LerpCamera()                   
    }

    rightCamera()
    {
        if(this.experience.curIndex < (this.islandCount-1))    
            this.experience.curIndex++;
        else
            this.experience.curIndex = 0; 
        this.LerpCamera()      
    }

    CalcCampPos()
    {}

    CalcCamLinearInitialPos()
    {
        const position = new THREE.Vector3()
        position.x = this.increment*2.5
        position.y = this.cameraYOffset
        position.z = this.cameraInitialOffset;
        return position
    }

    CalcCamLinearPos(index)
    {
        const position = new THREE.Vector3()
        if(this.mode == 0)
        {
            position.x = this.increment*index
            position.y = this.cameraLinearOffset.y;
            position.z = this.cameraLinearOffset.z;
        }
        else
        {        
            if(this.screenType ==  2)
            {
                console.log("set mobile distance");
                position.x = this.increment*index
                position.y = this.cameraLinearOffset.y+5;
                position.z =100;
            }
            else
            {
                position.x = this.increment*index
                position.y = this.cameraLinearOffset.y+5;
                position.z =this.cameraLinearOffset.z+5;
            }
        }
        return position
    }    

    CalcLinearPos(index)
    {
        const position = new THREE.Vector3()
           
            position.x = this.increment*index
            position.y = 0
            position.z = 0
        
        return position
    }
    CalcLinearInitialPos()
    {
        const position = new THREE.Vector3()
        position.x = this.increment*2.5
        position.y = 0
        position.z = 0
        return position
    }

    resetToIsland()
    {
        this.mode = 0;
        this.controlPos = this.instance.position
        this.controls.enableRotate = true;
        this.controls.enableZoom = true;
        this.controls.touches.ONE = THREE.TOUCH.ROTATE;
        this.controls.mouseButtons.LEFT = THREE.MOUSE.ROTATE;
        this.targetCamPos = this.CalcCamLinearPos(this.experience.curIndex)
        this.targetControlPos = this.CalcLinearPos(this.experience.curIndex)                          
    
        this.initialControlPos = this.controls.target
        this.minPan = new THREE.Vector3( -10, - 15, - 30 );
        this.maxPan = new THREE.Vector3( 110, 15, 30 );
        gsap.to(this.controlPos, {                        
            duration: 0.5,
            x: this.targetCamPos.x, y: this.targetCamPos.y + this.cameraYOffset, z: this.targetCamPos.z,
            onStart: ()=>{
                this.controls.enabled = false;
                },
            onUpdate: ()=>{
                this.instance.position.set(this.controlPos.x, this.controlPos.y, this.controlPos.z);
                },
            onComplete: ()=>{
                this.controls.enabled = true;
                }
    }).play();
        
    gsap.to(this.initialControlPos, {                        
        duration: 0.5,
        x: this.targetControlPos.x, y: this.targetControlPos.y, z: this.targetControlPos.z,
        onStart:  ()=> {
            this.controls.enabled = false;
            },
        onUpdate:  ()=> {                    
            this.instance.lookAt(this.initialControlPos)
            this.controls.update();
            },
        onComplete:  ()=> {
            this.minPan = this.targetControlPos.clone().sub( new THREE.Vector3(this.localPanLimit,this.localPanLimit,this.localPanLimit));
            this.maxPan = this.targetControlPos.clone().add( new THREE.Vector3(this.localPanLimit,this.localPanLimit,this.localPanLimit));
            this.controls.maxZoom = 25
            this.controls.maxDistance = 25
            this.controls.enabled = true;
            this.controls.minAzimuthAngle = Infinity;
        this.controls.maxAzimuthAngle = Infinity;
        this.controls.minPolarAngle = 0;
        this.controls.maxPolarAngle = Math.PI;
            }       
    }).play();
    }
    animateStart()
    {
        this.controlPos = this.instance.position.clone();
        if(this.screenType == 2)
        {
            this.targetCamPos = this.startCamIntroM.clone();        
            this.targetControlPos = this.starControlIntroM.clone();                          
        }
        else
        {
            this.targetCamPos = this.startCamIntro.clone();        
            this.targetControlPos = this.starControlIntro.clone();                              
        }        
        this.initialControlPos = this.controls.target.clone();        
        gsap.to(this.controlPos, {                        
            duration: 0.5,
            x: this.targetCamPos.x, y: this.targetCamPos.y, z: this.targetCamPos.z,
            onStart: ()=>{
                this.controls.enabled = false;
                },
            onUpdate: ()=>{
                this.instance.position.set(this.controlPos.x, this.controlPos.y, this.controlPos.z);
                },
            onComplete: ()=>{
                //this.controls.enabled = true;
                }
    }).play();
        
    gsap.to(this.initialControlPos, {                        
        duration: 0.5,
        x: this.targetControlPos.x, y: this.targetControlPos.y, z: this.targetControlPos.z,
        onStart:  ()=> {
            this.controls.enabled = false;
            },
        onUpdate:  ()=> {                    
            this.instance.lookAt(this.initialControlPos)
            this.controls.update();
            },
        onComplete:  ()=> {
            //console.log(this.instance.position);
            
            this.animateDown();
           //this.controls.enabled = true;
            }       
    }).play();
    }
    animateDown()
    {        
        this.controlPos = this.instance.position
        /*this.controls.enableRotate = true;
        this.controls.enableZoom = true;
        this.controls.touches.ONE = THREE.TOUCH.ROTATE;
        this.controls.mouseButtons.LEFT = THREE.MOUSE.ROTATE;*/
        if(this.screenType  == 2)
        {
            this.targetCamPos = this.CalcCamLinearPos(this.experience.curIndex)
            this.targetControlPos = this.CalcLinearPos(this.experience.curIndex)                          
        }
        else if(this.screenType ==1)
        {
            this.targetCamPos = this.CalcCamLinearInitialPos()
            this.targetCamPos.z += 15;
            this.targetControlPos = this.CalcLinearInitialPos(this.experience.curIndex)     
        }
        else
        {
            this.targetCamPos = this.CalcCamLinearInitialPos()
            this.targetControlPos = this.CalcLinearInitialPos(this.experience.curIndex)                             
        }
    
        this.initialControlPos = this.controls.target
        /*this.minPan = new THREE.Vector3( -10, - 15, -30 );
        this.maxPan = new THREE.Vector3( 110, 15, 30 );*/
        gsap.to(this.controlPos, {                        
            duration: 4,
            delay: 4.5,
            x: this.targetCamPos.x, y: this.targetCamPos.y + this.cameraYOffset, z: this.targetCamPos.z,
            onStart: ()=>{
                this.controls.enabled = false;
                },
            onUpdate: ()=>{
                this.instance.position.set(this.controlPos.x, this.controlPos.y, this.controlPos.z);
                },
            onComplete: ()=>{
                this.controls.enabled = true;
                }
    }).play();
        
    gsap.to(this.initialControlPos, {                        
        duration: 4,
            delay: 4.5,
        x: this.targetControlPos.x, y: this.targetControlPos.y, z: this.targetControlPos.z,
        onStart:  ()=> {
            this.controls.enabled = false;
            this.trigger('onStartDownAnimation');
            },
        onUpdate:  ()=> {                    
            this.instance.lookAt(this.initialControlPos)
            this.controls.update();
            },
        onComplete:  ()=> {
            /*this.minPan = this.targetControlPos.clone().sub( new THREE.Vector3(this.localPanLimit,this.localPanLimit,this.localPanLimit));
            this.maxPan = this.targetControlPos.clone().add( new THREE.Vector3(this.localPanLimit,this.localPanLimit,this.localPanLimit));
            this.controls.maxZoom = 20
            this.controls.maxDistance = 20
            this.controls.enabled = true;
            this.controls.minAzimuthAngle = Infinity;*/
            if(this.screenType == 2)
            {
                this.minPan = this.targetControlPos.clone().sub( new THREE.Vector3(this.localPanLimit,this.localPanLimit,this.localPanLimit));
                this.maxPan = this.targetControlPos.clone().add( new THREE.Vector3(this.localPanLimit,this.localPanLimit,this.localPanLimit));
                this.controls.maxZoom = 25
                this.controls.maxDistance = 25
            }
            else
            {
                this.controls.maxZoom = 110
                this.controls.minZoom = 8
                this.controls.maxDistance = 110
                this.controls.minDistance = 8
                this.minPan = new THREE.Vector3( 40, - 15, - 30 );
                this.maxPan = new THREE.Vector3( 55, 15, 30 );
            }
        this.introEnded = true;
        this.trigger('onEndIntro')
            }       
    }).play();
    }
    resetToSegment()
    {
        this.mode = 1;
        this.controlPos = this.instance.position
        this.targetCamPos = new THREE.Vector3(0,0,50);
        this.targetControlPos = new THREE.Vector3(0,0,0);
        if(this.experience.curIndex == 2)
        {
            this.targetCamPos = new THREE.Vector3(7,-5,20);
            this.targetControlPos = new THREE.Vector3(7,3,0);
        }
        if(this.experience.curIndex == 3)
        {
            this.targetCamPos = new THREE.Vector3(7,-5,35);
            this.targetControlPos = new THREE.Vector3(7,3,0);
        }
        if(this.experience.curIndex == 5)
        {            
            if(this.screenType !=2)        
            this.targetCamPos = new THREE.Vector3(0,15,35);
            else
            this.targetCamPos = new THREE.Vector3(0,15,65);
            this.targetControlPos = new THREE.Vector3(0,15,0);         
        }

        this.initialControlPos = this.controls.target
        
        this.minPan = new THREE.Vector3( -100 - 150, -300 );
        this.maxPan = new THREE.Vector3( 100, 150, 300 );
        
        this.controls.minZoom =0
        this.controls.minDistance = 0
        this.controls.maxZoom =1000
        this.controls.maxDistance = 1000
        gsap.to(this.controlPos, {                        
            duration: 0.5,
            x: this.targetCamPos.x, y: this.targetCamPos.y + this.cameraYOffset, z: this.targetCamPos.z,
            onStart: ()=>{
                this.controls.enabled = false;
                this.onAnimation = true;
                },
            onUpdate: ()=>{
                this.instance.position.set(this.controlPos.x, this.controlPos.y, this.controlPos.z);
                },
            onComplete: ()=>{
                this.controls.enabled = true;
                this.onAnimation = false;
                }
        }).play();
        
        gsap.to(this.initialControlPos, {                        
            duration: 0.5,
            x: this.targetControlPos.x, y: this.targetControlPos.y, z: this.targetControlPos.z,
            onStart:  ()=> {
                this.controls.enabled = false;
                },
            onUpdate:  ()=> {                    
                this.instance.lookAt(this.initialControlPos)
                this.controls.update();
                },
            onComplete:  ()=> {
                this.animateCamera();
                }       
        }).play();
    }

    animateCamera()
    {
        this.controlPos = this.instance.position
        if(this.screenType !=2)
        {
            switch(this.experience.curIndex)
            {
            case 0:
                    this.targetCamPos = this.dollyStartCam;
                    this.targetControlPos = this.dollyStartPos;
                break;
            case 1:
                    this.targetCamPos = this.dollyStartCam2;
                    this.targetControlPos = this.dollyStartPos;
                break;
            case 2:
                    this.targetCamPos = this.dollyStartCam3;
                    this.targetControlPos = this.dollyStartPos3;
                break;
            case 3:
                    this.targetCamPos = this.dollyStartCam4;
                    this.targetControlPos = this.dollyStartPos4;
                break;
            case 4:
                    this.targetCamPos = this.dollyStartCam5;
                    this.targetControlPos = this.dollyStartPos5;
                break;
            case 5:
                    this.targetCamPos = this.dollyStartCam6;
                    this.targetControlPos = this.dollyStartPos6;
                break;
            }
           
        }
        else
        {
            switch(this.experience.curIndex)
            {
            case 0:
                    this.targetCamPos = this.dollyStartCamM;
                    this.targetControlPos = this.dollyStartPosM;
                break;
            case 1:
                    this.targetCamPos = this.dollyStartCamM2;
                    this.targetControlPos = this.dollyStartPosM;
                break;
            case 2:
                    this.targetCamPos = this.dollyStartCamM3;
                    this.targetControlPos = this.dollyStartPosM3;
                break;
            case 3:
                    this.targetCamPos = this.dollyStartCamM4;
                    this.targetControlPos = this.dollyStartPosM4;
                break;
            case 4:
                    this.targetCamPos = this.dollyStartCamM5;
                    this.targetControlPos = this.dollyStartPosM5;
                break;
            case 5:
                    this.targetCamPos = this.dollyStartCamM6;
                    this.targetControlPos = this.dollyStartPosM6;
                break;
            }
            
        }
    
        this.initialControlPos = this.controls.target
       
        
        this.minPan = new THREE.Vector3( -100 - 150, -300 );
        this.maxPan = new THREE.Vector3( 100, 150, 300 );
        
        this.controls.minZoom =0
        this.controls.minDistance = 0
        this.controls.maxZoom =1000
        this.controls.maxDistance = 1000
        gsap.to(this.controlPos, {                        
            duration: 2.5,
            delay: 2,
            x: this.targetCamPos.x, y: this.targetCamPos.y + this.cameraYOffset, z: this.targetCamPos.z,
            onStart: ()=>{
                this.controls.enabled = false;
                this.onAnimation = true;
                },
            onUpdate: ()=>{
                this.instance.position.set(this.controlPos.x, this.controlPos.y, this.controlPos.z);
                },
            onComplete: ()=>{
                this.controls.enabled = true;
                this.onAnimation = false;
                }
    }).play();
        
    gsap.to(this.initialControlPos, {                        
        duration: 2.5,
        delay: 2,
        x: this.targetControlPos.x, y: this.targetControlPos.y, z: this.targetControlPos.z,
        onStart:  ()=> {
            this.controls.enabled = false;
            },
        onUpdate:  ()=> {                    
            this.instance.lookAt(this.initialControlPos)
            this.controls.update();
            },
        onComplete:  ()=> {
            this.controls.enableRotate = false;      
            this.controls.touches.ONE = THREE.TOUCH.PAN;
            this.controls.mouseButtons.LEFT = THREE.MOUSE.PAN;
            if(this.screenType !=2)
            {
                switch(this.experience.curIndex)
                {
                case 0:
                this.minPan = this.minDollyPan;
                this.maxPan = this.maxDollyPan;
                break;
                case 1:
                this.minPan = this.minDollyPan2;
                this.maxPan = this.maxDollyPan2;
                break;
                case 2:
                this.minPan = this.minDollyPan3;
                this.maxPan = this.maxDollyPan3;
                break;
                case 3:
                this.minPan = this.minDollyPan4;
                this.maxPan = this.maxDollyPan4;
                break;
                case 4:
                this.minPan = this.minDollyPan5;
                this.maxPan = this.maxDollyPan5;
                break;
                case 5:
                this.minPan = this.minDollyPan6;
                this.maxPan = this.maxDollyPan6;
                break;
                }
            }
            else
            {
                switch(this.experience.curIndex)
                {
                case 0:
                this.minPan = this.minDollyPanM;
                this.maxPan = this.maxDollyPanM;
                break;
                case 1:
                this.minPan = this.minDollyPanM2;
                this.maxPan = this.maxDollyPanM2;
                break;
                case 2:
                this.minPan = this.minDollyPanM3;
                this.maxPan = this.maxDollyPanM3;
                break;
                case 3:
                this.minPan = this.minDollyPanM4;
                this.maxPan = this.maxDollyPanM4;
                break;
                case 4:
                this.minPan = this.minDollyPanM5;
                this.maxPan = this.maxDollyPanM5;
                break;
                case 5:
                this.minPan = this.minDollyPanM6;
                this.maxPan = this.maxDollyPanM6;
                break;
                }
            }
            //console.log(this.instance.position)
            this.trigger('onSegmentIntroEnded');
            this.controls.enabled = true;
            this.controls.maxZoom = 50;
            this.controls.maxDistance = 50;
            this.controls.minZoom = 5;
            this.controls.minDistance = 5;
            
            }       
    }).play();
    }
}